<div class="modal-header">
	<h3 class="modal-title" id="modal-title">Confirm Account Deactivation</h3>
</div>
<div class="modal-body">
	<p>Your profile and all associated information will be permanently deleted from the platform. Once deactivated, you will need to create a new account to regain access.</p>
</div>
<div class="modal-footer text-right">
	<div class="button-wrapper">
		<button type="button" class="btn yes-button" (click)="deactivate()">Deactivate</button>
		<button type="button" class="btn no-button" (click)="cancel()">Cancel</button>
	</div>
</div>
